import { createPortal } from 'react-dom';
import { Tag } from '../UI';
import { usePortalDropdown } from '../../hooks/usePortalDropdown';
import type { StaffProfessionResponse } from '../../api/generated';
import styles from './InterventionFormModal.module.css';

const MIN_PANEL_WIDTH = 180;
const ADD_LABEL = '+';

interface AddProfessionMenuProps {
  // Competences not yet on the row; the menu renders nothing once none are left.
  competences: StaffProfessionResponse[];
  ariaLabel: string;
  onSelect: (competence: StaffProfessionResponse) => void;
}

// A "+" pill at the end of a requirement row's competence chips that lists the remaining
// competences. The picker below the table adds rows; this adds an alternative to one row.
export const AddProfessionMenu = ({ competences, ariaLabel, onSelect }: AddProfessionMenuProps) => {
  const { isOpen, position, panelStyle, triggerRef, panelRef, toggle, close } =
    usePortalDropdown<HTMLSpanElement>();

  if (competences.length === 0) return null;

  const select = (competence: StaffProfessionResponse): void => {
    onSelect(competence);
    close();
  };

  return (
    <>
      <span ref={triggerRef} className={styles.addProfessionTrigger}>
        <Tag label={ADD_LABEL} onClick={toggle} clickAriaLabel={ariaLabel} />
      </span>
      {isOpen &&
        createPortal(
          <div
            ref={panelRef}
            className={styles.skillDropdown}
            style={{ ...panelStyle, minWidth: Math.max(position.width, MIN_PANEL_WIDTH) }}
          >
            {competences.map((competence) => (
              <button
                key={competence.id}
                type="button"
                className={styles.skillDropdownOption}
                onMouseDown={(e) => {
                  e.preventDefault();
                  select(competence);
                }}
              >
                {competence.name}
              </button>
            ))}
          </div>,
          document.body
        )}
    </>
  );
};
